import * as Yup from 'yup';

export const editUserSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  role: Yup.string()
    .oneOf(['user', 'admin'], 'Role must be user or admin')
    .required('Role is required'),
  is_active: Yup.boolean(),
});

export const addUserSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  companyEmail: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(6, 'Minimum 6 characters')
    .required('Password is required'),
  role: Yup.string()
    .oneOf(['user', 'admin'], 'Role must be user or admin')
    .required('Role is required'),
  is_active: Yup.boolean(),
});

export default editUserSchema;
